export const eventRegion = (_config, _data, globalConfig) => {
  return {
    'event:region': `${globalConfig.region}`
  };
};